module.exports=function(scope){ return `// Pass your RSA public key to be used in PEM format
NSString *publicKey = @"-----BEGIN PUBLIC KEY-----\\nYour-Public-Key-Line-1-Here\\nYour-Public-Key-Line-2-Here\\nYour-Public-Key-Line-3-Here\\nYour-Public-Key-Line-4-Here\\nYour-Public-Key-Line-5-Here\\nYour-Public-Key-Line-6-Here\\nYour-Public-Key-Line-7-Here\\nYour-Public-Key-Etc.-Here\\n-----END PUBLIC KEY-----";
[Zoom.sdk setFacemapEncryptionKeyWithPublicKey: publicKey];
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/encryption-keys.m.tpl